module.exports = __webpack_public_path__ + "img/start-mini-1.202a7b1a.jpg";